/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AddProductsToInboundingListInput = {
  listId: string | number;
  products: Array<InboundingListProductInput>;
};

export type ClaimInboundingListInput = {
  listId: string | number;
};

export type CommonInboundingListStatus =
  | "INBOUNDING_LIST_STATUS_CLAIMED"
  | "INBOUNDING_LIST_STATUS_COMPLETED"
  | "INBOUNDING_LIST_STATUS_DRAFT"
  | "INBOUNDING_LIST_STATUS_UNCLAIMED"
  | "INBOUNDING_LIST_STATUS_UNSPECIFIED";

export type CommonInboundingType =
  | "INBOUNDING_TYPE_BAKERY"
  | "INBOUNDING_TYPE_LEKKERLAND"
  | "INBOUNDING_TYPE_NOT_DELIVERY"
  | "INBOUNDING_TYPE_OTHER_DELIVERY"
  | "INBOUNDING_TYPE_REWE"
  | "INBOUNDING_TYPE_UNSPECIFIED";

export type CommonListType =
  "LIST_TYPE_CANCELLED_ORDER" | "LIST_TYPE_REGULAR" | "LIST_TYPE_UNSPECIFIED";

export type CreateCheckInput = {
  metadataReason: TaskMetadataReason;
  priority: number;
  shelfNumber: string;
  sku: string;
  type: TaskType;
};

export type CreateInboundingListInput = {
  inboundingType?: CommonInboundingType | null | undefined;
  name: string;
  sscc?: string | null | undefined;
};

export type DeleteInboundingListInput = {
  listId: string | number;
};

export type DeleteInboundingListProductsInput = {
  listId: string | number;
  skus: Array<string>;
};

export type EditInboundingListInput = {
  listId: string | number;
  name: string;
};

export type EditProductsInInboundingListInput = {
  listId: string | number;
  products: Array<InboundingListProductInput>;
};

export type GetInboundingListClaimersInput = {
  listId: string | number;
};

export type GetInboundingListStatsInput = {
  status: Array<CommonInboundingListStatus>;
  type: Array<CommonListType>;
};

export type GetProductsInput = {
  skus: Array<string | number>;
};

export type InboundProductInput = {
  productId: string;
};

export type InboundingListProductInput = {
  handlingUnitSize: number;
  metadata?: InboundingListProductMetadataInput | null | undefined;
  quantity: number;
  sku: string;
};

export type InboundingListProductMetadataInput = {
  desadv?: string | null | undefined;
  expectedQuantity?: string | null | undefined;
  inboundingMethod?: string | null | undefined;
  inboundingUnit?: string | null | undefined;
  scannedEan?: string | null | undefined;
  sscc?: string | null | undefined;
};

export type InboundingListStatus =
  | "INBOUNDING_LIST_STATUS_CLAIMED"
  | "INBOUNDING_LIST_STATUS_COMPLETED"
  | "INBOUNDING_LIST_STATUS_DRAFT"
  | "INBOUNDING_LIST_STATUS_UNCLAIMED"
  | "INBOUNDING_LIST_STATUS_UNSPECIFIED";

export type ListProductStatus =
  | "LIST_PRODUCT_STATUS_CLAIMED"
  | "LIST_PRODUCT_STATUS_INBOUNDED"
  | "LIST_PRODUCT_STATUS_UNCLAIMED"
  | "LIST_PRODUCT_STATUS_UNSPECIFIED";

export type ReleaseInboundingListInput = {
  listId: string | number;
};

export type ShareInboundingListInput = {
  listId: string | number;
};

export type TaskMetadataReason =
  | "BBD"
  | "BBD_MISSING"
  | "DROPPING"
  | "EOY_INVENTORY"
  | "EOY_INVENTORY_RECOUNT"
  | "EXPENSIVE"
  | "EXTRA"
  | "FRESHNESS"
  | "INVENTORY_DISCREPANCY"
  | "LOW_STOCK"
  | "MISSING"
  | "ROLLING_8_WEEKS"
  | "ROLLING_12_WEEKS"
  | "ROLLING_INVENTORY"
  | "SPONTANEOUS_CORRECTION"
  | "TOBACCO";

export type TaskType =
  | "BBD_CHECK"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT_CHECK"
  | "FRESHNESS_CHECK"
  | "INVENTORY_DISCREPANCY_CHECK"
  | "STOCK_CHECK";

export type GetInboundingListsQueryVariables = Exact<{ [key: string]: never }>;

export type GetInboundingListsQuery = {
  getInboundingLists: {
    lists: Array<{
      id: string;
      claimerIds: Array<string> | null;
      sscc: string;
      status: Types.InboundingListStatus;
      name: string;
      creatorId: string;
      createdAt: string;
      inboundingType: Types.CommonInboundingType;
      listType: Types.CommonListType;
      orderId: string | null;
      products: Array<{
        id: string;
        sku: string;
        quantity: number;
        handlingUnitSize: number;
        imageUrl: string | null;
        status: Types.ListProductStatus | null;
        isInbounded: boolean | null;
      }> | null;
    }> | null;
  };
};

export type GetProductsQueryVariables = Exact<{
  input: Types.GetProductsInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type GetProductsQuery = {
  getProducts: {
    products: Array<{
      name: string;
      sku: string;
      imageUrl: string | null;
      bio: boolean | null;
      countryOfOrigin: { code: string | null };
      inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
    }>;
  };
};

export type GetPartialProductsFromClaimedListQueryVariables = Exact<{ [key: string]: never }>;

export type GetPartialProductsFromClaimedListQuery = {
  getProductsFromClaimedList: {
    claimerIds: Array<string> | null;
    name: string | null;
    products: Array<{
      id: string;
      sku: string;
      quantity: number;
      status: Types.ListProductStatus | null;
      isInbounded: boolean | null;
      handlingUnitSize: number;
      inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
    }>;
  };
};

export type GetProductsFromClaimedListQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductsFromClaimedListQuery = {
  getProductsFromClaimedList: {
    id: string | null;
    creatorId: string | null;
    claimerIds: Array<string> | null;
    name: string | null;
    inboundingType: Types.CommonInboundingType;
    listType: Types.CommonListType;
    orderId: string | null;
    sscc: string | null;
    products: Array<{
      id: string;
      name: string | null;
      sku: string;
      imageUrl: string | null;
      bio: boolean | null;
      numberOfShelfFacings: number | null;
      numberOfShelfStackings: number | null;
      isShelvedInHandlingUnits: boolean | null;
      quantity: number;
      handlingUnitSize: number;
      status: Types.ListProductStatus | null;
      isInbounded: boolean | null;
      countryOfOrigin: { code: string | null } | null;
      inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      units: Array<{ ean: string | null }> | null;
    }>;
  };
};

export type GetInboundingListClaimersQueryVariables = Exact<{
  input: Types.GetInboundingListClaimersInput;
}>;

export type GetInboundingListClaimersQuery = {
  getInboundingListClaimers: { claimerIds: Array<string> | null };
};

export type GetInboundingListStatsQueryVariables = Exact<{
  input: Types.GetInboundingListStatsInput;
}>;

export type GetInboundingListStatsQuery = {
  getInboundingListStats: {
    stats: Array<{ type: string | null; status: string | null; count: number | null }> | null;
  };
};

export type CreateInboundingListMutationVariables = Exact<{
  input: Types.CreateInboundingListInput;
}>;

export type CreateInboundingListMutation = { createInboundingList: { id: string } };

export type AddProductsToInboundingListMutationVariables = Exact<{
  input: Types.AddProductsToInboundingListInput;
}>;

export type AddProductsToInboundingListMutation = {
  addProductsToInboundingList: { success: boolean };
};

export type ShareInboundingListMutationVariables = Exact<{
  input: Types.ShareInboundingListInput;
}>;

export type ShareInboundingListMutation = { shareInboundingList: { success: boolean } };

export type ClaimInboundingListMutationVariables = Exact<{
  input: Types.ClaimInboundingListInput;
}>;

export type ClaimInboundingListMutation = { claimInboundingList: { success: boolean } };

export type InboundProductMutationVariables = Exact<{
  input: Types.InboundProductInput;
}>;

export type InboundProductMutation = { inboundProduct: { success: boolean } };

export type ReleaseInboundingListMutationVariables = Exact<{
  input: Types.ReleaseInboundingListInput;
}>;

export type ReleaseInboundingListMutation = { releaseInboundingList: { success: boolean } };

export type DeleteInboundingListProductsMutationVariables = Exact<{
  input: Types.DeleteInboundingListProductsInput;
}>;

export type DeleteInboundingListProductsMutation = {
  deleteInboundingListProducts: { success: boolean };
};

export type EditInboundingListMutationVariables = Exact<{
  input: Types.EditInboundingListInput;
}>;

export type EditInboundingListMutation = { editInboundingList: { success: boolean } };

export type EditProductsInInboundingListMutationVariables = Exact<{
  input: Types.EditProductsInInboundingListInput;
}>;

export type EditProductsInInboundingListMutation = {
  editProductsInInboundingList: { success: boolean };
};

export type DeleteInboundingListMutationVariables = Exact<{
  input: Types.DeleteInboundingListInput;
}>;

export type DeleteInboundingListMutation = { deleteInboundingList: { success: boolean } };

export type CreateCheckMutationVariables = Exact<{
  input: Types.CreateCheckInput;
}>;

export type CreateCheckMutation = { createCheck: { success: boolean } };

export const GetInboundingListsDocument = gql`
  query getInboundingLists {
    getInboundingLists {
      lists {
        id
        claimerIds
        products {
          id
          sku
          quantity
          handlingUnitSize
          imageUrl
          status
          isInbounded
        }
        sscc
        status
        name
        creatorId
        createdAt
        inboundingType
        listType
        orderId
      }
    }
  }
`;

/**
 * __useGetInboundingListsQuery__
 *
 * To run a query within a React component, call `useGetInboundingListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboundingListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboundingListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInboundingListsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInboundingListsQuery, GetInboundingListsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInboundingListsQuery, GetInboundingListsQueryVariables>(
    GetInboundingListsDocument,
    options,
  );
}
export function useGetInboundingListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInboundingListsQuery,
    GetInboundingListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInboundingListsQuery, GetInboundingListsQueryVariables>(
    GetInboundingListsDocument,
    options,
  );
}
// @ts-ignore
export function useGetInboundingListsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInboundingListsQuery,
    GetInboundingListsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInboundingListsQuery, GetInboundingListsQueryVariables>;
export function useGetInboundingListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInboundingListsQuery, GetInboundingListsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetInboundingListsQuery | undefined,
  GetInboundingListsQueryVariables
>;
export function useGetInboundingListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInboundingListsQuery, GetInboundingListsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInboundingListsQuery, GetInboundingListsQueryVariables>(
    GetInboundingListsDocument,
    options,
  );
}
export type GetInboundingListsQueryHookResult = ReturnType<typeof useGetInboundingListsQuery>;
export type GetInboundingListsLazyQueryHookResult = ReturnType<
  typeof useGetInboundingListsLazyQuery
>;
export type GetInboundingListsSuspenseQueryHookResult = ReturnType<
  typeof useGetInboundingListsSuspenseQuery
>;
export type GetInboundingListsQueryResult = Apollo.QueryResult<
  GetInboundingListsQuery,
  GetInboundingListsQueryVariables
>;
export const GetProductsDocument = gql`
  query getProducts($input: GetProductsInput!, $isAlwaysInbound: Boolean) {
    getProducts(input: $input, isAlwaysInbound: $isAlwaysInbound) {
      products {
        name
        sku
        imageUrl
        bio
        countryOfOrigin {
          code
        }
        inventoryEntry {
          shelfNumber
          stock {
            shelf
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useGetProductsQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> &
    ({ variables: GetProductsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
}
export function useGetProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProductsQuery, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProductsQuery | undefined, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    options,
  );
}
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<
  GetProductsQuery,
  GetProductsQueryVariables
>;
export const GetPartialProductsFromClaimedListDocument = gql`
  query getPartialProductsFromClaimedList {
    getProductsFromClaimedList {
      claimerIds
      name
      products {
        id
        sku
        quantity
        status
        isInbounded
        handlingUnitSize
        inventoryEntry {
          shelfNumber
          stock {
            shelf
          }
        }
      }
    }
  }
`;

/**
 * __useGetPartialProductsFromClaimedListQuery__
 *
 * To run a query within a React component, call `useGetPartialProductsFromClaimedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartialProductsFromClaimedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartialProductsFromClaimedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartialProductsFromClaimedListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >(GetPartialProductsFromClaimedListDocument, options);
}
export function useGetPartialProductsFromClaimedListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >(GetPartialProductsFromClaimedListDocument, options);
}
// @ts-ignore
export function useGetPartialProductsFromClaimedListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPartialProductsFromClaimedListQuery,
  GetPartialProductsFromClaimedListQueryVariables
>;
export function useGetPartialProductsFromClaimedListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPartialProductsFromClaimedListQuery,
        GetPartialProductsFromClaimedListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPartialProductsFromClaimedListQuery | undefined,
  GetPartialProductsFromClaimedListQueryVariables
>;
export function useGetPartialProductsFromClaimedListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPartialProductsFromClaimedListQuery,
        GetPartialProductsFromClaimedListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPartialProductsFromClaimedListQuery,
    GetPartialProductsFromClaimedListQueryVariables
  >(GetPartialProductsFromClaimedListDocument, options);
}
export type GetPartialProductsFromClaimedListQueryHookResult = ReturnType<
  typeof useGetPartialProductsFromClaimedListQuery
>;
export type GetPartialProductsFromClaimedListLazyQueryHookResult = ReturnType<
  typeof useGetPartialProductsFromClaimedListLazyQuery
>;
export type GetPartialProductsFromClaimedListSuspenseQueryHookResult = ReturnType<
  typeof useGetPartialProductsFromClaimedListSuspenseQuery
>;
export type GetPartialProductsFromClaimedListQueryResult = Apollo.QueryResult<
  GetPartialProductsFromClaimedListQuery,
  GetPartialProductsFromClaimedListQueryVariables
>;
export const GetProductsFromClaimedListDocument = gql`
  query getProductsFromClaimedList {
    getProductsFromClaimedList {
      id
      creatorId
      claimerIds
      name
      inboundingType
      listType
      orderId
      sscc
      products {
        id
        name
        sku
        imageUrl
        bio
        countryOfOrigin {
          code
        }
        inventoryEntry {
          shelfNumber
          stock {
            shelf
          }
        }
        units {
          ean
        }
        numberOfShelfFacings
        numberOfShelfStackings
        isShelvedInHandlingUnits
        quantity
        handlingUnitSize
        status
        isInbounded
      }
    }
  }
`;

/**
 * __useGetProductsFromClaimedListQuery__
 *
 * To run a query within a React component, call `useGetProductsFromClaimedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsFromClaimedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsFromClaimedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsFromClaimedListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProductsFromClaimedListQuery,
    GetProductsFromClaimedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductsFromClaimedListQuery, GetProductsFromClaimedListQueryVariables>(
    GetProductsFromClaimedListDocument,
    options,
  );
}
export function useGetProductsFromClaimedListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsFromClaimedListQuery,
    GetProductsFromClaimedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProductsFromClaimedListQuery,
    GetProductsFromClaimedListQueryVariables
  >(GetProductsFromClaimedListDocument, options);
}
// @ts-ignore
export function useGetProductsFromClaimedListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductsFromClaimedListQuery,
    GetProductsFromClaimedListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetProductsFromClaimedListQuery,
  GetProductsFromClaimedListQueryVariables
>;
export function useGetProductsFromClaimedListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductsFromClaimedListQuery,
        GetProductsFromClaimedListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetProductsFromClaimedListQuery | undefined,
  GetProductsFromClaimedListQueryVariables
>;
export function useGetProductsFromClaimedListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductsFromClaimedListQuery,
        GetProductsFromClaimedListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProductsFromClaimedListQuery,
    GetProductsFromClaimedListQueryVariables
  >(GetProductsFromClaimedListDocument, options);
}
export type GetProductsFromClaimedListQueryHookResult = ReturnType<
  typeof useGetProductsFromClaimedListQuery
>;
export type GetProductsFromClaimedListLazyQueryHookResult = ReturnType<
  typeof useGetProductsFromClaimedListLazyQuery
>;
export type GetProductsFromClaimedListSuspenseQueryHookResult = ReturnType<
  typeof useGetProductsFromClaimedListSuspenseQuery
>;
export type GetProductsFromClaimedListQueryResult = Apollo.QueryResult<
  GetProductsFromClaimedListQuery,
  GetProductsFromClaimedListQueryVariables
>;
export const GetInboundingListClaimersDocument = gql`
  query getInboundingListClaimers($input: GetInboundingListClaimersInput!) {
    getInboundingListClaimers(input: $input) {
      claimerIds
    }
  }
`;

/**
 * __useGetInboundingListClaimersQuery__
 *
 * To run a query within a React component, call `useGetInboundingListClaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboundingListClaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboundingListClaimersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInboundingListClaimersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInboundingListClaimersQuery,
    GetInboundingListClaimersQueryVariables
  > &
    ({ variables: GetInboundingListClaimersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInboundingListClaimersQuery, GetInboundingListClaimersQueryVariables>(
    GetInboundingListClaimersDocument,
    options,
  );
}
export function useGetInboundingListClaimersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInboundingListClaimersQuery,
    GetInboundingListClaimersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInboundingListClaimersQuery,
    GetInboundingListClaimersQueryVariables
  >(GetInboundingListClaimersDocument, options);
}
// @ts-ignore
export function useGetInboundingListClaimersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInboundingListClaimersQuery,
    GetInboundingListClaimersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetInboundingListClaimersQuery,
  GetInboundingListClaimersQueryVariables
>;
export function useGetInboundingListClaimersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInboundingListClaimersQuery,
        GetInboundingListClaimersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInboundingListClaimersQuery | undefined,
  GetInboundingListClaimersQueryVariables
>;
export function useGetInboundingListClaimersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInboundingListClaimersQuery,
        GetInboundingListClaimersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetInboundingListClaimersQuery,
    GetInboundingListClaimersQueryVariables
  >(GetInboundingListClaimersDocument, options);
}
export type GetInboundingListClaimersQueryHookResult = ReturnType<
  typeof useGetInboundingListClaimersQuery
>;
export type GetInboundingListClaimersLazyQueryHookResult = ReturnType<
  typeof useGetInboundingListClaimersLazyQuery
>;
export type GetInboundingListClaimersSuspenseQueryHookResult = ReturnType<
  typeof useGetInboundingListClaimersSuspenseQuery
>;
export type GetInboundingListClaimersQueryResult = Apollo.QueryResult<
  GetInboundingListClaimersQuery,
  GetInboundingListClaimersQueryVariables
>;
export const GetInboundingListStatsDocument = gql`
  query getInboundingListStats($input: GetInboundingListStatsInput!) {
    getInboundingListStats(input: $input) {
      stats {
        type
        status
        count
      }
    }
  }
`;

/**
 * __useGetInboundingListStatsQuery__
 *
 * To run a query within a React component, call `useGetInboundingListStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboundingListStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboundingListStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInboundingListStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInboundingListStatsQuery,
    GetInboundingListStatsQueryVariables
  > &
    ({ variables: GetInboundingListStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInboundingListStatsQuery, GetInboundingListStatsQueryVariables>(
    GetInboundingListStatsDocument,
    options,
  );
}
export function useGetInboundingListStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInboundingListStatsQuery,
    GetInboundingListStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInboundingListStatsQuery, GetInboundingListStatsQueryVariables>(
    GetInboundingListStatsDocument,
    options,
  );
}
// @ts-ignore
export function useGetInboundingListStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInboundingListStatsQuery,
    GetInboundingListStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInboundingListStatsQuery, GetInboundingListStatsQueryVariables>;
export function useGetInboundingListStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInboundingListStatsQuery,
        GetInboundingListStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInboundingListStatsQuery | undefined,
  GetInboundingListStatsQueryVariables
>;
export function useGetInboundingListStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInboundingListStatsQuery,
        GetInboundingListStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInboundingListStatsQuery, GetInboundingListStatsQueryVariables>(
    GetInboundingListStatsDocument,
    options,
  );
}
export type GetInboundingListStatsQueryHookResult = ReturnType<
  typeof useGetInboundingListStatsQuery
>;
export type GetInboundingListStatsLazyQueryHookResult = ReturnType<
  typeof useGetInboundingListStatsLazyQuery
>;
export type GetInboundingListStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetInboundingListStatsSuspenseQuery
>;
export type GetInboundingListStatsQueryResult = Apollo.QueryResult<
  GetInboundingListStatsQuery,
  GetInboundingListStatsQueryVariables
>;
export const CreateInboundingListDocument = gql`
  mutation createInboundingList($input: CreateInboundingListInput!) {
    createInboundingList(input: $input) {
      id
    }
  }
`;
export type CreateInboundingListMutationFn = Apollo.MutationFunction<
  CreateInboundingListMutation,
  CreateInboundingListMutationVariables
>;

/**
 * __useCreateInboundingListMutation__
 *
 * To run a mutation, you first call `useCreateInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboundingListMutation, { data, loading, error }] = useCreateInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInboundingListMutation,
    CreateInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInboundingListMutation, CreateInboundingListMutationVariables>(
    CreateInboundingListDocument,
    options,
  );
}
export type CreateInboundingListMutationHookResult = ReturnType<
  typeof useCreateInboundingListMutation
>;
export type CreateInboundingListMutationResult =
  Apollo.MutationResult<CreateInboundingListMutation>;
export type CreateInboundingListMutationOptions = Apollo.BaseMutationOptions<
  CreateInboundingListMutation,
  CreateInboundingListMutationVariables
>;
export const AddProductsToInboundingListDocument = gql`
  mutation addProductsToInboundingList($input: AddProductsToInboundingListInput!) {
    addProductsToInboundingList(input: $input) {
      success
    }
  }
`;
export type AddProductsToInboundingListMutationFn = Apollo.MutationFunction<
  AddProductsToInboundingListMutation,
  AddProductsToInboundingListMutationVariables
>;

/**
 * __useAddProductsToInboundingListMutation__
 *
 * To run a mutation, you first call `useAddProductsToInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToInboundingListMutation, { data, loading, error }] = useAddProductsToInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddProductsToInboundingListMutation,
    AddProductsToInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddProductsToInboundingListMutation,
    AddProductsToInboundingListMutationVariables
  >(AddProductsToInboundingListDocument, options);
}
export type AddProductsToInboundingListMutationHookResult = ReturnType<
  typeof useAddProductsToInboundingListMutation
>;
export type AddProductsToInboundingListMutationResult =
  Apollo.MutationResult<AddProductsToInboundingListMutation>;
export type AddProductsToInboundingListMutationOptions = Apollo.BaseMutationOptions<
  AddProductsToInboundingListMutation,
  AddProductsToInboundingListMutationVariables
>;
export const ShareInboundingListDocument = gql`
  mutation shareInboundingList($input: ShareInboundingListInput!) {
    shareInboundingList(input: $input) {
      success
    }
  }
`;
export type ShareInboundingListMutationFn = Apollo.MutationFunction<
  ShareInboundingListMutation,
  ShareInboundingListMutationVariables
>;

/**
 * __useShareInboundingListMutation__
 *
 * To run a mutation, you first call `useShareInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareInboundingListMutation, { data, loading, error }] = useShareInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShareInboundingListMutation,
    ShareInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShareInboundingListMutation, ShareInboundingListMutationVariables>(
    ShareInboundingListDocument,
    options,
  );
}
export type ShareInboundingListMutationHookResult = ReturnType<
  typeof useShareInboundingListMutation
>;
export type ShareInboundingListMutationResult = Apollo.MutationResult<ShareInboundingListMutation>;
export type ShareInboundingListMutationOptions = Apollo.BaseMutationOptions<
  ShareInboundingListMutation,
  ShareInboundingListMutationVariables
>;
export const ClaimInboundingListDocument = gql`
  mutation claimInboundingList($input: ClaimInboundingListInput!) {
    claimInboundingList(input: $input) {
      success
    }
  }
`;
export type ClaimInboundingListMutationFn = Apollo.MutationFunction<
  ClaimInboundingListMutation,
  ClaimInboundingListMutationVariables
>;

/**
 * __useClaimInboundingListMutation__
 *
 * To run a mutation, you first call `useClaimInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimInboundingListMutation, { data, loading, error }] = useClaimInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClaimInboundingListMutation,
    ClaimInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClaimInboundingListMutation, ClaimInboundingListMutationVariables>(
    ClaimInboundingListDocument,
    options,
  );
}
export type ClaimInboundingListMutationHookResult = ReturnType<
  typeof useClaimInboundingListMutation
>;
export type ClaimInboundingListMutationResult = Apollo.MutationResult<ClaimInboundingListMutation>;
export type ClaimInboundingListMutationOptions = Apollo.BaseMutationOptions<
  ClaimInboundingListMutation,
  ClaimInboundingListMutationVariables
>;
export const InboundProductDocument = gql`
  mutation inboundProduct($input: InboundProductInput!) {
    inboundProduct(input: $input) {
      success
    }
  }
`;
export type InboundProductMutationFn = Apollo.MutationFunction<
  InboundProductMutation,
  InboundProductMutationVariables
>;

/**
 * __useInboundProductMutation__
 *
 * To run a mutation, you first call `useInboundProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInboundProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inboundProductMutation, { data, loading, error }] = useInboundProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboundProductMutation(
  baseOptions?: Apollo.MutationHookOptions<InboundProductMutation, InboundProductMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InboundProductMutation, InboundProductMutationVariables>(
    InboundProductDocument,
    options,
  );
}
export type InboundProductMutationHookResult = ReturnType<typeof useInboundProductMutation>;
export type InboundProductMutationResult = Apollo.MutationResult<InboundProductMutation>;
export type InboundProductMutationOptions = Apollo.BaseMutationOptions<
  InboundProductMutation,
  InboundProductMutationVariables
>;
export const ReleaseInboundingListDocument = gql`
  mutation releaseInboundingList($input: ReleaseInboundingListInput!) {
    releaseInboundingList(input: $input) {
      success
    }
  }
`;
export type ReleaseInboundingListMutationFn = Apollo.MutationFunction<
  ReleaseInboundingListMutation,
  ReleaseInboundingListMutationVariables
>;

/**
 * __useReleaseInboundingListMutation__
 *
 * To run a mutation, you first call `useReleaseInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseInboundingListMutation, { data, loading, error }] = useReleaseInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleaseInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReleaseInboundingListMutation,
    ReleaseInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReleaseInboundingListMutation, ReleaseInboundingListMutationVariables>(
    ReleaseInboundingListDocument,
    options,
  );
}
export type ReleaseInboundingListMutationHookResult = ReturnType<
  typeof useReleaseInboundingListMutation
>;
export type ReleaseInboundingListMutationResult =
  Apollo.MutationResult<ReleaseInboundingListMutation>;
export type ReleaseInboundingListMutationOptions = Apollo.BaseMutationOptions<
  ReleaseInboundingListMutation,
  ReleaseInboundingListMutationVariables
>;
export const DeleteInboundingListProductsDocument = gql`
  mutation deleteInboundingListProducts($input: DeleteInboundingListProductsInput!) {
    deleteInboundingListProducts(input: $input) {
      success
    }
  }
`;
export type DeleteInboundingListProductsMutationFn = Apollo.MutationFunction<
  DeleteInboundingListProductsMutation,
  DeleteInboundingListProductsMutationVariables
>;

/**
 * __useDeleteInboundingListProductsMutation__
 *
 * To run a mutation, you first call `useDeleteInboundingListProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInboundingListProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInboundingListProductsMutation, { data, loading, error }] = useDeleteInboundingListProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInboundingListProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInboundingListProductsMutation,
    DeleteInboundingListProductsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteInboundingListProductsMutation,
    DeleteInboundingListProductsMutationVariables
  >(DeleteInboundingListProductsDocument, options);
}
export type DeleteInboundingListProductsMutationHookResult = ReturnType<
  typeof useDeleteInboundingListProductsMutation
>;
export type DeleteInboundingListProductsMutationResult =
  Apollo.MutationResult<DeleteInboundingListProductsMutation>;
export type DeleteInboundingListProductsMutationOptions = Apollo.BaseMutationOptions<
  DeleteInboundingListProductsMutation,
  DeleteInboundingListProductsMutationVariables
>;
export const EditInboundingListDocument = gql`
  mutation editInboundingList($input: EditInboundingListInput!) {
    editInboundingList(input: $input) {
      success
    }
  }
`;
export type EditInboundingListMutationFn = Apollo.MutationFunction<
  EditInboundingListMutation,
  EditInboundingListMutationVariables
>;

/**
 * __useEditInboundingListMutation__
 *
 * To run a mutation, you first call `useEditInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInboundingListMutation, { data, loading, error }] = useEditInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditInboundingListMutation,
    EditInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditInboundingListMutation, EditInboundingListMutationVariables>(
    EditInboundingListDocument,
    options,
  );
}
export type EditInboundingListMutationHookResult = ReturnType<typeof useEditInboundingListMutation>;
export type EditInboundingListMutationResult = Apollo.MutationResult<EditInboundingListMutation>;
export type EditInboundingListMutationOptions = Apollo.BaseMutationOptions<
  EditInboundingListMutation,
  EditInboundingListMutationVariables
>;
export const EditProductsInInboundingListDocument = gql`
  mutation editProductsInInboundingList($input: EditProductsInInboundingListInput!) {
    editProductsInInboundingList(input: $input) {
      success
    }
  }
`;
export type EditProductsInInboundingListMutationFn = Apollo.MutationFunction<
  EditProductsInInboundingListMutation,
  EditProductsInInboundingListMutationVariables
>;

/**
 * __useEditProductsInInboundingListMutation__
 *
 * To run a mutation, you first call `useEditProductsInInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProductsInInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProductsInInboundingListMutation, { data, loading, error }] = useEditProductsInInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProductsInInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditProductsInInboundingListMutation,
    EditProductsInInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditProductsInInboundingListMutation,
    EditProductsInInboundingListMutationVariables
  >(EditProductsInInboundingListDocument, options);
}
export type EditProductsInInboundingListMutationHookResult = ReturnType<
  typeof useEditProductsInInboundingListMutation
>;
export type EditProductsInInboundingListMutationResult =
  Apollo.MutationResult<EditProductsInInboundingListMutation>;
export type EditProductsInInboundingListMutationOptions = Apollo.BaseMutationOptions<
  EditProductsInInboundingListMutation,
  EditProductsInInboundingListMutationVariables
>;
export const DeleteInboundingListDocument = gql`
  mutation deleteInboundingList($input: DeleteInboundingListInput!) {
    deleteInboundingList(input: $input) {
      success
    }
  }
`;
export type DeleteInboundingListMutationFn = Apollo.MutationFunction<
  DeleteInboundingListMutation,
  DeleteInboundingListMutationVariables
>;

/**
 * __useDeleteInboundingListMutation__
 *
 * To run a mutation, you first call `useDeleteInboundingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInboundingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInboundingListMutation, { data, loading, error }] = useDeleteInboundingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInboundingListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInboundingListMutation,
    DeleteInboundingListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteInboundingListMutation, DeleteInboundingListMutationVariables>(
    DeleteInboundingListDocument,
    options,
  );
}
export type DeleteInboundingListMutationHookResult = ReturnType<
  typeof useDeleteInboundingListMutation
>;
export type DeleteInboundingListMutationResult =
  Apollo.MutationResult<DeleteInboundingListMutation>;
export type DeleteInboundingListMutationOptions = Apollo.BaseMutationOptions<
  DeleteInboundingListMutation,
  DeleteInboundingListMutationVariables
>;
export const CreateCheckDocument = gql`
  mutation createCheck($input: CreateCheckInput!) {
    createCheck(input: $input) {
      success
    }
  }
`;
export type CreateCheckMutationFn = Apollo.MutationFunction<
  CreateCheckMutation,
  CreateCheckMutationVariables
>;

/**
 * __useCreateCheckMutation__
 *
 * To run a mutation, you first call `useCreateCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckMutation, { data, loading, error }] = useCreateCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCheckMutation, CreateCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCheckMutation, CreateCheckMutationVariables>(
    CreateCheckDocument,
    options,
  );
}
export type CreateCheckMutationHookResult = ReturnType<typeof useCreateCheckMutation>;
export type CreateCheckMutationResult = Apollo.MutationResult<CreateCheckMutation>;
export type CreateCheckMutationOptions = Apollo.BaseMutationOptions<
  CreateCheckMutation,
  CreateCheckMutationVariables
>;
